import { useAppSelector } from '@redux/hooks';
import classNames from 'classnames';
import React, { type FC } from 'react';
import type { Decorated } from 'types/vendor';
import type { NavItemProps } from '../nav/types';
import VendorPledge from '../vendor_pledge';
import { RelatedSearches } from './components/related_searches';
import VendorDescription from './components/vendor_description';
import Styles from './styles.scss';

export const LiteVendorAbout: FC<NavItemProps> = () => {
	const vendor = useAppSelector((state) => state.vendor.vendor as Decorated);
	const { description, name, pledges } = vendor;

	return (
		<div
			className={classNames(Styles.aboutWrapper, {
				[Styles.aboutPledge]: pledges?.plantation,
			})}
			data-testid="about-wrapper"
		>
			<VendorDescription description={description} vendorName={name} />
			{pledges?.plantation && <VendorPledge />}
			<RelatedSearches />
		</div>
	);
};
